import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, G } from "react-native-svg";
import AppTheme from "../../../AppTheme";
import MoodColors from "../MoodColors";

export default function VeryBad(props) {
  const color = props.color || MoodColors.VeryBad;
  const opacity = props.selected ? 1 : AppTheme.moodOpacity;
  const width = props.width || 36;
  const height = props.height || 36;

  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G opacity={opacity}>
          <Path
            d="M30.7279 30.7279C37.7573 23.6985 37.7573 12.3015 30.7279 5.27208C23.6985 -1.75736 12.3015 -1.75736 5.27205 5.27208C-1.75739 12.3015 -1.75739 23.6985 5.27205 30.7279C12.3015 37.7574 23.6985 37.7574 30.7279 30.7279Z"
            fill={color}
          />
          <Path
            d="M25.0453 19.2755C25.9565 19.2755 26.6953 18.5368 26.6953 17.6255C26.6953 16.7143 25.9565 15.9755 25.0453 15.9755C24.134 15.9755 23.3953 16.7143 23.3953 17.6255C23.3953 18.5368 24.134 19.2755 25.0453 19.2755Z"
            fill={AppTheme.almostBlack}
          />
          <Path
            opacity="0.61"
            d="M25.3726 17.4137C25.6063 17.4137 25.7958 17.2242 25.7958 16.9905C25.7958 16.7568 25.6063 16.5674 25.3726 16.5674C25.1389 16.5674 24.9495 16.7568 24.9495 16.9905C24.9495 17.2242 25.1389 17.4137 25.3726 17.4137Z"
            fill="white"
          />
          <Path
            d="M26.3776 10.9462C26.489 12.5581 27.5718 14.0645 29.0642 14.6844"
            stroke={AppTheme.almostBlack}
            strokeWidth="0.928161"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M12.5525 10.8764C11.7915 12.3016 10.1876 13.2357 8.57227 13.1886"
            stroke={AppTheme.almostBlack}
            strokeWidth="0.928161"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M11.8432 19.4342C12.7545 19.4342 13.4932 18.6954 13.4932 17.7842C13.4932 16.8729 12.7545 16.1342 11.8432 16.1342C10.9319 16.1342 10.1932 16.8729 10.1932 17.7842C10.1932 18.6954 10.9319 19.4342 11.8432 19.4342Z"
            fill={AppTheme.almostBlack}
          />
          <Path
            opacity="0.61"
            d="M12.2423 17.5723C12.476 17.5723 12.6655 17.3829 12.6655 17.1492C12.6655 16.9154 12.476 16.726 12.2423 16.726C12.0086 16.726 11.8192 16.9154 11.8192 17.1492C11.8192 17.3829 12.0086 17.5723 12.2423 17.5723Z"
            fill="white"
          />
          <Path
            d="M24.0529 28.2364C23.5735 25.6131 21.0079 23.574 18.3414 23.5806C15.6748 23.5871 13.1669 25.5508 12.4014 28.1039C16.608 27.236 20.5576 27.0939 24.0529 28.2364Z"
            fill={AppTheme.almostBlack}
          />
        </G>
      </Svg>
    </TouchableOpacity>
  );
}
